import React, {useEffect, useState} from 'react';
import {HStack, Switch, VStack} from "native-base";
import {useDispatch, useSelector} from "react-redux";
import {updateScheduleSetting} from "../../../../../../../redux/ScheduleSlice";
import {isMobile} from "../../../../../../../services/Helpers";
import CustomSwitch from "../../../../../../common/CustomSwitch";
import AppText from "../../../../../../common/AppText";
import {GlobalStyleAttributes} from "../../../../../../../styles/GlobalStyles";
import {t} from "../../../../../../../services/i18n";

const SmsNotification = (props) => {
    const { values, setFieldValue } = props;
    const box = useSelector((state) => state.box.box);
    const [isChecked, setIsChecked] = useState(!!values?.allowSmsWaitList);
    const dispatch = useDispatch()

    useEffect(() => {
        if(box) setIsChecked(!!box.allow_sms_to_waiting_list)
    }, [box.allow_sms_to_waiting_list]);

    const toggle = (val) => {
        const value = val ? 1 : 0
        if(isMobile) dispatch(updateScheduleSetting({allow_sms_to_waiting_list: value}))
        else {
            setFieldValue('allowSmsWaitList', value)
        }
        setIsChecked(val)
    }

    return (
        <>
            {isMobile ? <CustomSwitch isChecked={isChecked} onToggle={toggle} style={{ width: isMobile && 'inherit' }} />
            :
            <VStack space={'1rem'}>
                <HStack justifyContent={'space-between'} alignItems={'center'}>
                    <AppText fontSize={GlobalStyleAttributes.fonts.standard16} boldFont>{t('smsNotificationLbl')}</AppText>
                    <CustomSwitch isChecked={isChecked} onToggle={toggle} style={{ width: isMobile && 'inherit' }} />
                </HStack>
                <AppText fontSize={GlobalStyleAttributes.fonts.standard16}>{t('smsNotificationTxt')}</AppText>
            </VStack>}
        </>
    );
};

export default SmsNotification;
